import { useState } from "react";

import { ChevronDown } from "react-feather";

import SideMenu from "../..";
import { ContainerShowMenu, DropDownCPMobileContainer } from "./styles";

const DropDownCPMobile = () => {
  const [isOpen, setIsOpen] = useState(false);

  const handleClick = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <DropDownCPMobileContainer onClick={handleClick}>
        <ChevronDown className="arrow-down-cp" />
        <p>Painel de controle</p>
      </DropDownCPMobileContainer>
      {isOpen && (
        <ContainerShowMenu>
          <SideMenu />
        </ContainerShowMenu>
      )}
    </>
  );
};

export default DropDownCPMobile;
